module.exports = __webpack_public_path__ + "media/images/site/infantil_sala-81ac3f0b29cfea2960c8ee26e919cd4a.jpg";